import ServiceError from '../../models/classes/ServiceError';
import { GiftCardContract, IGiftCardService } from '../../types/GiftCard';
import { GiftCardServiceConfig } from '../../types/ServiceConfigurations';
import { CredentialedParameters } from '../RequestParameters';
import { Endpoints } from '../../utils/constants';

const ApiError = new ServiceError('GiftCardService', 'error contacting API');

class GiftCardService implements IGiftCardService {
  private storeUrl: string;

  constructor(config: GiftCardServiceConfig) {
    this.storeUrl = config.apiUrl;
  }

  async validateGiftCardCode(code: string): Promise<GiftCardContract | null> {
    try {
      const response = await window.fetch(
        `${this.storeUrl}${Endpoints.GIFT_CARDS}${code}`,
        CredentialedParameters
      );
      if (response.status === 200) {
        const responseJson = await response.json();
        return responseJson.data as GiftCardContract;
      }
      return null;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      throw ApiError;
    }
  }
}

export default GiftCardService;
